export default __webpack_public_path__ + "Detect logo.svg";